import React, { Fragment } from "react"
import { useTranslation } from "react-i18next"

import { moment } from "utils"
import OdhAddressForm from "./OdhAddressForm"
import classes from "./index.module.scss"

const OrderDetailsHeader = props => {
  const { order, setOrders } = props

  const [t] = useTranslation()

  const showPaidDate =
    !!order.paymentDate &&
    order.accountRole === "access" &&
    order.orderStatus === "paid"

  const showCancelReasons =
    !!order.cancelReasons &&
    order.orderStatus === "canceled"

  return (
    <Fragment>
      {
        order.dailyOrderNumber !== undefined &&
        <div className={classes["title-container"]}>
          <span className={classes["title"]}>
            {t("شماره_روزانه")}
          </span>
          <div className={classes["date"]}>
            {String(order.dailyOrderNumber).padStart(3, "0")}
          </div>
        </div>
      }

      {
        !!order.referenceCode &&
        <div className={classes["title-container"]}>
          <span className={classes["title"]}>
            {t("کد_پیگیری")}
          </span>
          <div className={classes["date"]}>
            {order.referenceCode}
          </div>
        </div>
      }

      {
        order.deliveryType === "dineIn" &&
        <div className={classes["title-container"]}>
          <span className={classes["title"]}>
            {t("شماره_میز")}
          </span>
          <div className={classes["date"]}>
            {order.tableNumber}
          </div>
        </div>
      }

      {
        order.deliveryType === "cinema" &&
        <div className={classes["title-container"]}>
          <span className={classes["title"]}>
            {t("سالن_سینما")}
          </span>
          <div className={classes["date"]}>
            {order.cinemaSolonNumber}
          </div>
        </div>
      }

      {
        order.deliveryType === "delivery" &&
        <OdhAddressForm
          order={order}
          setOrders={setOrders}
        />
      }

      {
        order.deliveryType === "selfPickup" &&
        <div className={classes["title-container"]}>
          <span className={classes["title"]}>
            {t("بیرون_بر")}
          </span>
        </div>
      }

      <div className={classes["title-container"]}>
        <span className={classes["title"]}>
          {t("تاریخ_ایجاد_سفارش")}
        </span>
        <div className={classes["date"]}>
          {moment(order.date).format("jYYYY/jMM/jDD - HH:mm")}
        </div>
      </div>

      {
        showPaidDate &&
        <div className={classes["title-container"]}>
          <span className={classes["title"]}>
            {t("تاریخ_پرداخت")}
          </span>
          <div className={classes["date"]}>
            {moment(order.paymentDate).format("jYYYY/jMM/jDD - HH:mm")}
          </div>
        </div>
      }

      {
        !!order.canceledAt &&
        <div className={classes["title-container"]}>
          <span className={classes["title"]}>
            {t("تاریخ_لغو_سفارش")}
          </span>
          <div className={classes["date"]}>
            {moment(order.canceledAt).format("jYYYY/jMM/jDD - HH:mm")}
          </div>
        </div>
      }

      {
        !!order.deliveredAt &&
        <div className={classes["title-container"]}>
          <span className={classes["title"]}>
            {t("تاریخ_تکمیل_سفارش")}
          </span>
          <div className={classes["date"]}>
            {moment(order.deliveredAt).format("jYYYY/jMM/jDD - HH:mm")}
          </div>
        </div>
      }

      {
        !!order.dispatchedAt &&
        <div className={classes["title-container"]}>
          <span className={classes["title"]}>
            {t("تاریخ_خروج_از_انبار")}
          </span>
          <div className={classes["date"]}>
            {moment(order.dispatchedAt).format("jYYYY/jMM/jDD - HH:mm")}
          </div>
        </div>
      }

      {
        showCancelReasons &&
        <div className={classes["title-container"]}>
          <span className={classes["title"]}>
            {t("دلیل_لغو_سفارش")}
          </span>
          <div className={classes["cancel-note"]}>
            {order.cancelReasons}
          </div>
        </div>
      }
    </Fragment>
  )
}

export default OrderDetailsHeader
